import { render, staticRenderFns } from "./demographic-questionnaire.vue?vue&type=template&id=346593e6&scoped=true&"
import script from "./demographic-questionnaire.vue?vue&type=script&lang=js&"
export * from "./demographic-questionnaire.vue?vue&type=script&lang=js&"
import style0 from "./demographic-questionnaire.vue?vue&type=style&index=0&id=346593e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346593e6",
  null
  
)

export default component.exports